import React from 'react'
import InventoryFieldsRow from './InventoryFieldsRow'

/**
 * InventorySection component - Section for Cash/Product/Physical reward types
 * Contains inventory fields (quota, leftover inventory, limit per store)
 * @param {Object} props - Component props
 * @param {Object} props.formData - Form data containing inventory fields
 * @param {Function} props.handleQuotaChange - Function to handle quota field changes
 * @param {Function} props.handleLeftoverInventoryChange - Function to handle leftover inventory field changes
 * @param {Function} props.handleLimitPerStoreChange - Function to handle limit per store field changes
 * @param {Function} props.handleMaxQuantityPerOrderChange - Function to handle max quantity per order field changes
 * @param {boolean} props.isQuotaDisabled - Whether quota field should be disabled
 * @param {string} props.quotaValidationError - Validation error message for quota field
 * @param {string} props.limitValidationError - Validation error message for limit per store field
 * @returns {JSX.Element} The rendered InventorySection component
 */
const InventorySection = ({
  formData,
  handleQuotaChange,
  handleLeftoverInventoryChange,
  handleLimitPerStoreChange,
  handleMaxQuantityPerOrderChange,
  isQuotaDisabled,
  quotaValidationError,
  limitValidationError,
  maxQuantityPerOrderValidationError,
}) => {

  return (
    <InventoryFieldsRow
      formData={formData}
      isQuotaDisabled={isQuotaDisabled}
      handleQuotaChange={handleQuotaChange}
      handleLeftoverInventoryChange={handleLeftoverInventoryChange}
      handleLimitPerStoreChange={handleLimitPerStoreChange}
      handleMaxQuantityPerOrderChange={handleMaxQuantityPerOrderChange}
      quotaValidationError={quotaValidationError}
      limitValidationError={limitValidationError}
      maxQuantityPerOrderValidationError={maxQuantityPerOrderValidationError}
    />
  )
}

export default InventorySection

